import { defineMessages } from 'react-intl';

export default defineMessages({
  share: {
    id: 'share-overlay.share',
    defaultMessage: 'Share this video',
  },
});



// WEBPACK FOOTER //
// ./src/widget/player-widget/components/player/info-overlay/share/translations.js